import React, { useState } from 'react';
import useIntersectionCallback from '@nykaa/utils/IObserver/useIntersectCallback';
function LazyLoad({ children, bottomMargin = 0, rightMargin = 0, wrapperClassName, placeHolder, }) {
    const [isInAreaOfInterest, setIsInAreaOfInterest] = useState(false);
    const [setNodeReference] = useIntersectionCallback({
        rootMargin: `0px ${rightMargin}px ${bottomMargin}px 0px`,
    }, () => setIsInAreaOfInterest(true), true);
    return (React.createElement("div", { className: wrapperClassName, ref: setNodeReference }, isInAreaOfInterest ? (React.createElement(React.Fragment, null, children)) : (placeHolder)));
}
export default LazyLoad;
